import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useController, useFormContext, } from 'react-hook-form';
import { QuestionWrapper, TagWrapper, Title, Wrapper, } from './styles';
function QuestionList(props) {
    const { questions, field, handleChange } = props;
    const { control } = useFormContext();
    const { field: { onChange } } = useController({
        control,
        name: field,
    });
    return (_jsx(Wrapper, { half: questions.length % 2 === 0, children: questions.map((question, idx) => (_jsxs(QuestionWrapper, { hasTag: typeof question.tag !== 'undefined', children: [_jsx("input", { type: "radio", id: `${field}-${idx}`, name: field, value: question.value, onClick: () => {
                        onChange(question.value);
                        handleChange(question.value);
                    } }), _jsx("label", { htmlFor: `${field}-${idx}`, children: _jsx(Title, { children: question.title }) }), question.tag && (_jsx(TagWrapper, { children: _jsx("span", { className: `tag ${question.tag.type ? `tag--${question.tag.type}` : ''}`, children: question.tag.title }) }))] }, idx))) }));
}
export default QuestionList;
